import { makeObservable, observable, action } from 'mobx'

class PoliciesEntity {
    constructor(
        id,
        commission,
        commissionAmount,
        createdAt,
        displayName,
        insuranceCompany,
        insuranceCompanyShort,
        smallCompanyLogo,
        multiQuoteType,
        subscriptionAmount,
        subtitle,
        title,
        validFrom,
        validTo,
        status,
        numberOfAmendments,
        asset,
        brokerName,
        sellerName,
        origin,
        missingInspection,
        isRenovation
    ) {
        this.id = id
        this.asset = asset
        this.brokerName = brokerName
        this.sellerName = sellerName
        this.origin = origin
        this.commission = commission
        this.commissionAmount = commissionAmount
        this.createdAt = createdAt
        this.displayName = displayName
        this.insuranceCompany = insuranceCompany
        this.insuranceCompanyShort = insuranceCompanyShort
        this.smallCompanyLogo = smallCompanyLogo
        this.multiQuoteType = multiQuoteType
        this.subscriptionAmount = subscriptionAmount
        this.subtitle = subtitle
        this.title = title
        this.validTo = validTo
        this.validFrom = validFrom
        this.status = status
        this.numberOfAmendments = numberOfAmendments
        this.origin = origin
        this.missingInspection = missingInspection
        this.isRenovation = Boolean(isRenovation)
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false

        makeObservable(this, {
            isNewlyAdded: observable,
            isSilentlyUpdated: observable,
            setSilentHighlight: action,
            clearSilentHighlight: action,
        })
    }

    setSilentHighlight({ isNewlyAdded = false, isSilentlyUpdated = false } = {}) {
        this.isNewlyAdded = isNewlyAdded
        this.isSilentlyUpdated = isSilentlyUpdated
    }

    clearSilentHighlight() {
        this.isNewlyAdded = false
        this.isSilentlyUpdated = false
    }

    get isActivated() {
        return this.status === 'activated'
    }

    get isCanceled() {
        return this.status === 'canceled'
    }

    get isEnded() {
        return this.status === 'ending'
    }

    get isPending() {
        return this.status === 'pending'
    }

    get isExpired() {
        return this.status === 'expired'
    }

    get isInEmission() {
        return this.status === 'in_emission'
    }

    get isError() {
        return this.status === 'error'
    }

    static fromJson({
        id,
        commission,
        commissionAmount,
        createdAt,
        displayName,
        insuranceCompanyLogos,
        multiQuoteType,
        subscriptionAmount,
        subtitle,
        title,
        validFrom,
        validTo,
        status,
        numberOfAmendments,
        asset,
        brokerName,
        sellerName,
        origin,
        missingInspection,
        isRenovation,
    }) {
        return new PoliciesEntity(
            id,
            commission,
            commissionAmount,
            createdAt,
            displayName,
            insuranceCompanyLogos.displayLongName,
            insuranceCompanyLogos.displayName,
            insuranceCompanyLogos.small,
            multiQuoteType,
            subscriptionAmount,
            subtitle,
            title,
            validFrom,
            validTo,
            status,
            numberOfAmendments,
            asset,
            brokerName,
            sellerName,
            origin,
            missingInspection,
            isRenovation
        )
    }
}

export default PoliciesEntity
